import React from 'react';
import { Helmet } from 'react-helmet';
import { siteUrl } from '@utils/siteConfig';
import { CustomHelmetProps } from './CustomHelmetProps';

export const CustomHelmet: React.FC<CustomHelmetProps> = ({
	title,
	ogTitle,
	metaDescription,
	ogDescription,
	ogImage = `${siteUrl}/images/og/uniwersalny_og_white.png`,
}) => {
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={metaDescription} />
			<meta property="og:description" content={ogDescription} />
			<meta property="og:title" content={ogTitle} />
			<meta property="og:image" content={ogImage} />
		</Helmet>
	);
};
